import { Platform, PlatformOSType } from 'react-native';

export function getPlatform(): PlatformOSType {
  return Platform.OS;
}
